import { useStore } from "../app/store.ts";
import { CubeSpinner } from "./CubeSpinner.tsx";
import { COLOR_BG, Z_MODAL } from "./tokens.ts";

/**
 * Full-screen loading overlay.
 *
 * Covers the entire application while a scene is loading. Rendered at
 * the App level so it works across page transitions (library → viewport).
 */
export function LoadingOverlay() {
  const loading = useStore((s) => s.loading);
  if (!loading) return null;

  return (
    <>
      <style>{`
@keyframes lo-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}`}</style>
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: Z_MODAL - 2,
          background: COLOR_BG,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "lo-fade-in 0.15s ease-out both",
        }}
      >
        <CubeSpinner size={48} />
      </div>
    </>
  );
}
